module.exports = __webpack_public_path__ + "img/icon_phone.86bc5d0d.svg";